import script from "./LeaderboardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderboardCard.vue?vue&type=script&setup=true&lang=js"

import "./LeaderboardCard.vue?vue&type=style&index=0&id=37873cff&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37873cff"]])

export default __exports__